export default __webpack_public_path__ + "language-dropdown/ES.png";